<div class="team-cert-audit" testId="team-cert-audit-page">
  <div class="page-title" testId="team-cert-audit-title">{{ 'team.cert.audit.title' | i18n }}</div>

  <div class="stats" testId="team-cert-audit-stats">
    <div class="stat-card pending" testId="team-cert-audit-stat-pending">
      <div class="stat-label">{{ 'team.cert.audit.stats.pending' | i18n }}</div>
      <div class="stat-value">{{ pendingCount }}</div>
    </div>
    <div class="stat-card approved" testId="team-cert-audit-stat-approved">
      <div class="stat-label">{{ 'team.cert.audit.stats.approved' | i18n }}</div>
      <div class="stat-value">{{ approvedCount }}</div>
    </div>
    <div class="stat-card rejected" testId="team-cert-audit-stat-rejected">
      <div class="stat-label">{{ 'team.cert.audit.stats.rejected' | i18n }}</div>
      <div class="stat-value">{{ rejectedCount }}</div>
    </div>
  </div>

  <nz-card class="table-card" [nzBordered]="false" testId="team-cert-audit-table-card">
    <div class="filters" testId="team-cert-audit-filters">
      <nz-select class="status-select" [(ngModel)]="statusFilter" (ngModelChange)="onSearch()" testId="team-cert-audit-status-select">
        <nz-option [nzValue]="'All'" [nzLabel]="'team.cert.audit.filter.all' | i18n" />
        <nz-option [nzValue]="'Audit'" [nzLabel]="'team.cert.audit.status.audit' | i18n" />
        <nz-option [nzValue]="'Audited'" [nzLabel]="'team.cert.audit.status.audited' | i18n" />
        <nz-option [nzValue]="'Back'" [nzLabel]="'team.cert.audit.status.back' | i18n" />
      </nz-select>

      <nz-input-group class="keyword-input" nzPrefixIcon="search" testId="team-cert-audit-keyword-input-group">
        <input
          nz-input
          [(ngModel)]="keyword"
          [placeholder]="'team.cert.audit.search.placeholder' | i18n"
          (keyup.enter)="onSearch()"
          testId="team-cert-audit-keyword-input"
        />
      </nz-input-group>

      <button nz-button nzType="default" (click)="onReset()" testId="team-cert-audit-reset-button">{{ 'common.reset' | i18n }}</button>
      <button nz-button nzType="primary" (click)="onSearch()" testId="team-cert-audit-search-button">{{ 'common.search' | i18n }}</button>
    </div>

    <div class="table-wrapper">
      <nz-spin [nzSpinning]="loading" testId="team-cert-audit-table-spin">
        <nz-table
          [nzData]="list"
          [nzFrontPagination]="false"
          [nzShowPagination]="false"
          [nzScroll]="{ y: 'var(--team-cert-table-height, calc(100vh - 420px))' }"
          testId="team-cert-audit-table"
        >
          <thead>
            <tr>
              <th>{{ 'team.cert.audit.table.tenant-name' | i18n }}</th>
              <th>{{ 'team.cert.audit.table.status' | i18n }}</th>
              <th>{{ 'team.cert.audit.table.submitted-at' | i18n }}</th>
              <th class="op-col">{{ 'team.cert.audit.table.actions' | i18n }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of list; let i = index" [testId]="'team-cert-audit-table-row-' + i">
              <td>
                <div class="tenant-name">{{ row.name || '-' }}</div>
                <div class="tenant-sub">{{ row.shortName || '' }}</div>
              </td>
              <td>
                <nz-tag [nzColor]="getStatusTagColor(row.certificateStatus || '')">
                  {{ getStatusLabel(row.certificateStatus || '') }}
                </nz-tag>
              </td>
              <td>{{ formatDateTime(row.certificateTime || row.updateTime) || '-' }}</td>
              <td class="op-col">
                <div class="op-actions">
                  <button nz-button class="op-btn view-btn" (click)="view(row)" [testId]="'team-cert-audit-view-button-' + i">
                    <span nz-icon nzType="eye" class="op-btn-icon"></span>
                    {{ 'team.cert.audit.action.view' | i18n }}
                  </button>
                  <button
                    *ngIf="(row.certificateStatus || '') === 'Audit'"
                    nz-button
                    nzType="primary"
                    class="op-btn approve-btn"
                    (click)="approve(row)"
                    [testId]="'team-cert-audit-approve-button-' + i"
                  >
                    <span nz-icon nzType="check-circle" class="op-btn-icon"></span>
                    {{ 'team.cert.audit.action.approve' | i18n }}
                  </button>
                  <button
                    *ngIf="(row.certificateStatus || '') === 'Audit'"
                    nz-button
                    nzDanger
                    class="op-btn reject-btn"
                    (click)="reject(row)"
                    [testId]="'team-cert-audit-reject-button-' + i"
                  >
                    <span nz-icon nzType="close-circle" class="op-btn-icon"></span>
                    {{ 'team.cert.audit.action.reject' | i18n }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <div class="table-pagination" testId="team-cert-audit-pagination-section">
          <nz-pagination
            [nzTotal]="total"
            [nzPageIndex]="pageIndex"
            [nzPageSize]="pageSize"
            [nzShowSizeChanger]="true"
            [nzShowQuickJumper]="true"
            (nzPageIndexChange)="onPageIndexChange($event)"
            (nzPageSizeChange)="onPageSizeChange($event)"
            testId="team-cert-audit-pagination"
          />
        </div>
      </nz-spin>
    </div>
  </nz-card>

  <ng-template #detailTpl let-data>
    <div class="detail" testId="team-cert-audit-detail">
      <div class="detail-row">
        <div class="detail-label">{{ 'team.cert.audit.detail.tenant-name' | i18n }}</div>
        <div class="detail-value">{{ data?.tenantName || '-' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">{{ 'team.cert.audit.detail.status' | i18n }}</div>
        <div class="detail-value">
          <nz-tag [nzColor]="getStatusTagColor(data?.status || '')">
            {{ getStatusLabel(data?.status || '') }}
          </nz-tag>
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-label">{{ 'team.cert.audit.detail.submitted-at' | i18n }}</div>
        <div class="detail-value">{{ formatDateTime(data?.submittedAt) || '-' }}</div>
      </div>
      <div class="detail-row" *ngIf="data?.failReason">
        <div class="detail-label">{{ 'team.cert.audit.detail.fail-reason' | i18n }}</div>
        <div class="detail-value">{{ data?.failReason }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">{{ 'team.cert.audit.detail.unified-number' | i18n }}</div>
        <div class="detail-value">{{ data?.unifiedNumber || '-' }}</div>
      </div>
      <div class="detail-row">
        <div class="detail-label">{{ 'team.cert.audit.detail.representative-number' | i18n }}</div>
        <div class="detail-value">{{ data?.representativeNumber || '-' }}</div>
      </div>

      <div class="detail-files">
        <div class="files-title">
          {{ 'team.cert.audit.detail.files' | i18n }} <span class="files-count">({{ data?.files?.length || 0 }})</span>
        </div>
        <div class="file-list" *ngIf="data?.files?.length; else emptyFiles">
          <div class="file-item" *ngFor="let file of data.files">
            <div class="file-icon">
              <span nz-icon nzType="file-text"></span>
            </div>
            <div class="file-meta">
              <div class="file-name">{{ file.name }}</div>
              <div class="file-size" *ngIf="file.sizeText">{{ file.sizeText }}</div>
            </div>
            <button
              nz-button
              nzType="text"
              class="file-download"
              (click)="previewFile(file)"
              testId="team-cert-audit-detail-file-preview-button"
            >
              <span nz-icon nzType="eye"></span>
            </button>
          </div>
        </div>
        <ng-template #emptyFiles>
          <div class="files-empty">{{ 'team.cert.audit.detail.files-empty' | i18n }}</div>
        </ng-template>
      </div>
    </div>
  </ng-template>

  <ng-template #detailFooterTpl>
    <div class="detail-footer">
      <button
        *ngIf="currentDetailStatus === 'Audit'"
        nz-button
        nzType="default"
        nzDanger
        class="footer-reject"
        (click)="currentDetailRow && reject(currentDetailRow)"
        [ngStyle]="{ 'background-color': '#ff4d4f', 'border-color': '#ff4d4f', color: '#fff' }"
        testId="team-cert-audit-detail-reject-button"
      >
        {{ 'team.cert.audit.action.reject' | i18n }}
      </button>
      <button
        *ngIf="currentDetailStatus === 'Audit'"
        nz-button
        nzType="default"
        class="footer-approve"
        (click)="currentDetailRow && approve(currentDetailRow)"
        [ngStyle]="{ 'background-color': '#52c41a', 'border-color': '#52c41a', color: '#fff' }"
        testId="team-cert-audit-detail-approve-button"
      >
        {{ 'team.cert.audit.action.approve' | i18n }}
      </button>
      <button nz-button nzType="default" class="footer-close" (click)="closeDetailModal()" testId="team-cert-audit-detail-close-button">
        {{ 'common.close' | i18n }}
      </button>
    </div>
  </ng-template>

  <ng-template #rejectReasonTpl>
    <div class="reject-modal" testId="team-cert-audit-reject-modal">
      <div class="reject-title">
        {{ 'team.cert.audit.reject.reason-label' | i18n: { name: rejectTenantName } }}
      </div>
      <textarea
        nz-input
        rows="4"
        [(ngModel)]="rejectReason"
        [placeholder]="'team.cert.audit.reject.placeholder' | i18n"
        (ngModelChange)="rejectReasonTouched = false"
        testId="team-cert-audit-reject-reason-textarea"
      ></textarea>
      <div class="reject-error" *ngIf="rejectReasonTouched && !rejectReason.trim()">
        {{ 'team.cert.audit.reject.required' | i18n }}
      </div>
    </div>
  </ng-template>

  <ng-template #rejectFooterTpl>
    <div class="reject-footer">
      <button nz-button nzType="default" (click)="onRejectCancel()" testId="team-cert-audit-reject-cancel-button">{{
        'common.cancel' | i18n
      }}</button>
      <button nz-button nzType="primary" nzDanger (click)="submitRejectReason()" testId="team-cert-audit-reject-confirm-button">
        {{ 'common.confirm' | i18n }}
      </button>
    </div>
  </ng-template>
</div>
